import * as React from "react";
import { Button, Text, Badge } from "@fluentui/react-components";
import { useTranslation } from 'react-i18next';

interface NavButtonProps {
  icon: React.ReactElement;
  label: string;
  isActive?: boolean;
  onClick: () => void;
  showBadge?: boolean;
}

const NavButton: React.FC<NavButtonProps> = ({ 
  icon, 
  label,  
  onClick, 
  isActive = false,
  showBadge = true 
}) => {
  const { t } = useTranslation();
  const activeBadgeText = t('common.active', 'Active');

  return (
    <Button
      appearance={isActive ? "primary" : "subtle"}
      icon={icon}
      onClick={onClick}
      style={{ 
        justifyContent: 'flex-start',
        width: '100%',
        textAlign: 'left'
      }}
      size="large"
    >
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '100%',
        alignItems: 'center'
      }}>
        <Text>{label}</Text>
        {isActive && showBadge && (
          <Badge appearance="filled" color="brand" size="small">
            {activeBadgeText}
          </Badge>
        )}
      </div>
    </Button>
  );
};

export default NavButton;